export function gridColumnsForItemCount(itemCount) {
  const count = Number(itemCount || 0);
  if (count <= 9) return 3;
  if (count <= 16) return 4;
  return 5;
}

export function instructionForUniqueCount(uniqueCount) {
  const count = Number(uniqueCount || 1);
  if (count === 1) return 'Eşi olmayan görseli bul.';
  return `Eşi olmayan ${count} görseli bul.`;
}

export function replayOddOneOutEvents(boards, events) {
  const safeBoards = Array.isArray(boards) ? boards : [];
  const safeEvents = Array.isArray(events) ? events : [];
  let boardIndex = 0;
  let completedBoardCount = 0;
  const selectedByBoard = {};
  const correctByBoard = {};

  safeEvents.forEach((event) => {
    const board = safeBoards[boardIndex];
    if (!board || String(event.board_id) !== String(board.board_id)) return;
    const boardId = String(board.board_id);
    const itemId = String(event.item_id);
    const itemExists = (board.items || []).some((item) => String(item.item_id) === itemId);
    if (!itemExists) return;
    selectedByBoard[boardId] = selectedByBoard[boardId] || new Set();
    correctByBoard[boardId] = correctByBoard[boardId] || new Set();
    if (selectedByBoard[boardId].has(itemId)) return;
    selectedByBoard[boardId].add(itemId);
    const solutions = new Set((board.solution_item_ids || []).map(String));
    if (solutions.has(itemId)) correctByBoard[boardId].add(itemId);
    if (correctByBoard[boardId].size === solutions.size) {
      completedBoardCount += 1;
      boardIndex += 1;
    }
  });

  return {
    boardIndex,
    completedBoardCount,
    selectedByBoard,
    correctByBoard,
  };
}

export function countCorrectEvents(boards, events) {
  const solutionsByBoard = new Map(
    (boards || []).map((board) => [
      String(board.board_id),
      new Set((board.solution_item_ids || []).map(String)),
    ]),
  );
  return (events || []).reduce((count, event) => (
    solutionsByBoard.get(String(event.board_id))?.has(String(event.item_id)) ? count + 1 : count
  ), 0);
}
